<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2020-12-14 01:36:00
    Description : 标签选择
  -->
  <div class="tag-select" v-if="visible" :style="{ top: top }">
    <div class="title">官方标签</div>
    <div
      v-if="type !== 'virtual'"
    >
      <div
        class="tag"
        v-for="(item, i) in tagsListTemp[0]"
        :key="i"
        :class="{ checked: list.includes(item) }"
        @click="click(item)"
      >
        {{ item }}
      </div>
    </div>
    <div v-else>
      <div class='tag-group'>
          <div class='tag-item'>
            <span style='color: #939393;'>
              一级标签
            </span>
              <i class='el-icon-caret-left' style='font-size: 30px; color: #c7c7c7;' @click='handleLeftCaretClick(levelList1.length, 1)'></i>
              <div class='tag-content' ref='tagContent'>
                <div
                  class='tag'
                  v-for='(item, i) in levelList1'
                  :key='i'
                  :id="`_${i}1`"
                  :class='{ checked: levelList.includes(item.keyword)}'
                  @click='levelKeyword1 = item.keyword'
                >
                  {{ item.keyword }}
                </div>
              </div>
              <i class='el-icon-caret-right' style='font-size: 30px; color: #c7c7c7;' @click='handleRightCaretClick(levelList1.length,1)'></i>
          </div>
          <div class='tag-item' v-if='showLevelList2'>
            <span style='color: #939393;'>
                二级标签
              </span>
              <i class='el-icon-caret-left' style='font-size: 30px; color: #c7c7c7;' @click='handleLeftCaretClick(levelList2.length, 2)'></i>
              <div class='tag-content' ref='tagContent'>
                <div
                  class='tag'
                  v-for='(item, i) in levelList2'
                  :key='i'
                  :id="`_${i}2`"
                  :class='{ checked: levelList.includes(item.keyword)}'
                  @click='levelKeyword2 = item.keyword'
                >
                  {{ item.keyword }}
                </div>
              </div>
              <i class='el-icon-caret-right' style='font-size: 30px; color: #c7c7c7;' @click='handleRightCaretClick(levelList2.length, 2)'></i>
          </div>
          <div class='tag-item' v-if='showLevelList3'>
              <span style='color: #939393;'>
                  三级标签
                </span>
            <i class='el-icon-caret-left' style='font-size: 30px; color: #c7c7c7;' @click='handleLeftCaretClick(levelList3.length, 3)'></i>
            <div class='tag-content' ref='tagContent'>
              <div
                class='tag'
                v-for='(item, i) in levelList3'
                :key='i'
                :id="`_${i}3`"
                :class='{ checked: levelList.includes(item.keyword)}'
                @click='levelKeyword3 = item.keyword'
              >
                {{ item.keyword }}
              </div>
            </div>
            <i class='el-icon-caret-right' style='font-size: 30px; color: #c7c7c7;' @click='handleRightCaretClick(levelList3.length, 3)'></i>
          </div>
      </div>
    </div>
    <div class="title">自定义标签</div>
    <div class="tag" v-if="!isInput" @click="inputClick">+</div>
    <el-input
      v-if="isInput"
      class="tag-input"
      maxlength="10"
      ref="tagInput"
      v-model="value"
      @blur="inputBlur"
      @change="inputBlur"
    ></el-input>
    <div
      class="tag"
      v-for="(item, i) in tagsListTemp[1]"
      :key="-i - 1"
      :class="{ checked: list.includes(item) }"
      @click="click(item)"
    >
      {{ item }}
    </div>
    <div class="footer">
      <el-button type="primary" style="width: 200px" @click="confirm">
        确定
      </el-button>
      <el-button type="warning" @click="$emit('visibleChange', false)">
        取消
      </el-button>
    </div>
  </div>
</template>

<script>
import { getVirtualTags } from '../../api/material'
export default {
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false,
    },
    tagsList: {
      type: Array,
      default: () => [],
    },
    tags: {
      type: String,
      default: "",
    },
  },
  watch: {
    tags(new_value, old_value) {
      if (new_value != old_value) {
        this.list = this.tags.split(";");
      }
    },
    tagsList(new_value, old_value) {
      console.log(new_value);
      if (new_value != old_value) {
        this.tagsListTemp = this.new_value;
      }
    },
    levelKeyword1(_) {
      if (this.levelList2.length !== 0) {
        this.levelKeyword2 = this.levelList2[0].keyword
      } else {
        this.levelKeyword2 = ''
      }
      if (this.levelList3.length !== 0) {
        this.levelKeyword3 = this.levelList3[0].keyword
      } else {
        this.levelKeyword3 = ''
      }
    },
    levelKeyword2(_) {
      if (this.levelList3.length === 0) {
        this.levelKeyword3 = ''
      } else {
        this.levelKeyword3 = this.levelList3[0].keyword
      }
    },
    levelList: {
      handler(val) {
      if(this.type === 'virtual') {
          this.tagsListTemp[0] = val
          this.list = [...val, ...this.officialTag]
        }
      },
      deep: true
    }
  },
  data() {
    return {
      top: "30px",
      list: [],
      isInput: false,
      value: "",
      tagsListTemp: [],
      levelList1: [],
      left: {
        count1: 0,
        count2: 0,
        count3: 0
      },
      right: {
        count1: 2,
        count2: 2,
        count3: 2,
      },
      levelKeyword1: '',
      levelKeyword2: '',
      levelKeyword3: '',
      officialTag: []
    };
  },
  created() {
    this.tagsListTemp = this.tagsList
    if(this.type === 'virtual') {
      this.getVirtualTags();
    }
  },
  methods: {
    handleRightCaretClick(length, level) {
      if(length > 3) {
        if (this.right[`count${level}`] > length - 1) {
          this.left[`count${level}`] = this.right[`count${level}`] - 3
        } else {
          if (this.right[`count${level}`] === length - 1) {
            this.left[`count${level}`] = this.right[`count${level}`] - 3
          } else {
            console.log(this.right[`count${level}`])
            this.right[`count${level}`] = this.right[`count${level}`] + 1
            const el = this.$el.querySelector('#_' + (this.right[`count${level}`]) + level)
            el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
          }
        }
      }
    },
    handleLeftCaretClick(length, level) {
      if(length > 3) {
        if (this.left[`count${level}`] < 0) {
          this.right[`count${level}`] = 2
        } else {
          if (this.left[`count${level}`] === 0) {
            this.right[`count${level}`] = 2
            const el = this.$el.querySelector('#_' + this.left[`count${level}`] + level)
            el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
          } else {
            const el = this.$el.querySelector('#_' + --this.left[`count${level}`] + level)
            el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
          }
        }
      }
    },
    async getVirtualTags(){
      const res = await getVirtualTags()
      if (res.contentList) {
        this.levelList1 = res.contentList.map(it => ({
          ...it
        }))
        this.levelKeyword1 = res.contentList[0].keyword
        this.levelKeyword2 = res.contentList[0].contentList[0].keyword
        this.levelKeyword3 = res.contentList[0].contentList[0].contentList[0].keyword
      }
    },
    confirm() {
      if (this.type === 'virtual') {
        this.list.map((el, i) => {
          if (el === undefined || el === "") {
            this.list.splice(i, 1);
          }
        });
        this.$emit("change", this.list.filter(i => Boolean(i)).join(";"));
        this.$emit("visibleChange", false);
      } else {
        this.list.map((el, i) => {
          if (el === undefined || el === "") {
            this.list.splice(i, 1);
          }
        });
        this.$emit("change", this.list.join(";"));
        this.$emit("visibleChange", false);
      }
    },
    click(item) {
      if (this.type === 'virtual') {
        if (this.officialTag.includes(item)) {
          this.officialTag.splice(this.officialTag.indexOf(item), 1)
          this.list.splice(this.list.indexOf(item), 1)
        } else {
          this.officialTag.push(item);
          this.list.push(item);
        }
      } else {
        if (this.list.includes(item)) {
          this.list = this.list.map((el) => {
            if (el !== item) {
              return el;
            }
          });
        } else {
          this.list.push(item);
        }
      }
    },
    inputClick() {
      this.isInput = true;
      setTimeout(() => {
        this.$refs.tagInput.focus();
      }, 0);
    },
    inputBlur() {
      this.isInput = false;
      if (this.value) {
        if (!this.tagsListTemp[1].includes(this.value)) {
          if (this.tagsListTemp[1].length <= 9) {
            this.tagsListTemp[1].unshift(this.value);
            this.value = "";
          } else {
            this.$message.error("最多添加9个自定义标签");
          }
        } else {
          this.$message.error("不能添加相同的自定义标签内容");
        }
      }
    },
  },
  computed: {
    levelList2() {
      return this.levelList1.find(it => it.keyword === this.levelKeyword1)?.contentList.filter(i => Boolean(i?.keyword)) ?? []
    },
    showLevelList2() {
      return this.levelList2.length !== 0 && this.levelList2.filter(i => Boolean(i?.keyword)).length !== 0
    },
    levelList3() {
      return this.levelList2.find(it => it.keyword === this.levelKeyword2)?.contentList.filter(i => Boolean(i?.keyword)) ?? []
    },
    showLevelList3() {
      return this.levelList3.length !== 0 && this.levelList3.filter(i => Boolean(i?.keyword)).length !== 0
    },
    levelList() {
      return [this.levelKeyword1, this.levelKeyword2, this.levelKeyword3]
    },

  }
};
</script>

<style lang="less" scoped>
.tag-select {
  position: absolute;
  width: 484px;
  // height: 340px;
  padding: 6px;
  border-radius: 4px;
  box-shadow: 0 10px 40px 10px rgba(51, 51, 51, 0.4);
  background: #ffffff;
  z-index: 100;
  .title {
    display: inline-block;
    width: 100%;
    font-size: 12px;
    font-weight: 700;
    color: #666666;
    padding-left: 3px;
    margin-bottom: 12px;
  }
  .content {
    font-size: 12px;
    color: #999;
    display: inline;
  }
  .tag {
    display: inline-block;
    width: 32%;
    margin-right: 0.5%;
    margin-bottom: 6px;
    border-radius: 4px;
    font-size: 12px;
    border: solid 1px #dcdcdc;
    color: #333333;
    text-align: center;
    user-select: none;
    cursor: pointer;
    transition: all 0.2s;
  }
  .tag-input {
    width: 32%;
    margin-right: 0.5%;
  }
  .checked {
    border: 1px solid #ff5b67;
    transition: all 0.2s;
  }
  .footer {
    position: relative;
    left: 25%;
    // top: 100px;
  }
}
.tag-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.tag-content {
  overflow: hidden;
  white-space: nowrap;
  width: 350px;
}
.tag-item {
  display: flex;
}
</style>
